<yat-add-payment-method-common id="c03f08d5-5205-402d-9eb1-57f7fb363413" [showWalletButtons]="true" [walletButtonsTemplate]="walletButtonTmpl"> </yat-add-payment-method-common>
<ng-template #walletButtonTmpl let-activeWalletData>
  <ng-container *ngIf="toWalletPaymentMethodType(activeWalletData); let activeWallet"
    ><yat-subscription-wallet-button id="82a87bc4-dac8-439f-a471-c045fba626bf" [activeWallet]="activeWallet"></yat-subscription-wallet-button></ng-container
></ng-template>
